import React from "react";
import type { FC } from "react";

import { Content, ContentsView } from "../../Content";

import type { OmitOfUnion } from "../../../types/react";
import type { ContentTextProps } from "../../Content/Content/components/Text/ContentText";

const TITLE_CORE_TEST_ID = "title-core-test-id";

export type VibeTextCoreProps = OmitOfUnion<
    ContentTextProps,
    "alignmentX" | "quote" | "asList"
>;

export const VibeTextCore: FC<VibeTextCoreProps> = ({
    "data-tsid": tsid = TITLE_CORE_TEST_ID,
    ...props
}) => {
    return (
        <ContentsView.Row>
            <ContentsView.Content alignmentX="center">
                <Content.Text data-tsid={tsid} alignmentX="center" {...props} />
            </ContentsView.Content>
        </ContentsView.Row>
    );
};

export default VibeTextCore;
